import { useState } from "react";
import  styles from './Add.module.scss'
import {  ref, uploadBytesResumable , getDownloadURL, deleteObject} from "firebase/storage";
import { db, storage } from '../../../firebase/Config';
import { toast } from "react-toastify";
import { addDoc, collection, doc, setDoc, Timestamp } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Loader from "../../Loader/Loader";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import  {selectProducts} from '../../../Redux/Slice/ProductSlice';

const intialState = {

  name: '',
  imageUrl: '',
  category: '',
  price: 0,
  desc: '',
  brand: '',
  color: '',
  sizes: []


}


const AddProduct = () => {

  const {id} = useParams();
  const products = useSelector(selectProducts)

  const productEdit = products.find((item) => item.id === id)




  function detectForm (id, f1, f2) {
    if(id === 'ADD') {
      return f1
    }
    return f2

  };



    const [product, setProduct] = useState(() => {
      const newState = detectForm(id ,
         {...intialState},
          productEdit)
          return newState

    });
    // const [product, setProduct] = useState({
    // ...intialState
    // })

      const navigate = useNavigate()
      // category
      const categories= [
        {id: 1, name: 'Tshirts'},
        {id: 2, name: 'Hoodies'},
    
        {id: 3, name: 'Slides'},
    
        {id: 4, name: 'Boxers'},
        {id: 5, name: 'Shoes'},

    
    
    ]
// brand
    const productBrand =[
    {id: 1 , name: 'Ashuluxe'},
    {id: 2 , name: 'Nike'},
    {id: 3 , name: 'Gucci'},

    {id: 4 , name: 'Nike'},
    {id: 5 , name: 'Plane Tees'},
    {id: 6 , name: 'Lacoster'},
    {id: 7 , name: 'Thrifts'},
    {id: 8 , name: 'Bags'},
    {id: 9 , name: 'Jordern'},

    ];  

    // sizes 
    const sizes = [
      { id: 1, name: 'XS', selected: false },
      { id: 2, name: 'S', selected: false },
      { id: 3, name: 'M', selected: false },
      { id: 4, name: 'XL', selected: false },
      { id: 5, name: 'L', selected: false },
    ];
    
    
//  image function (storing image to fire store)

    const[uploadProgress , setUploadProgress] = useState(0)
    const [isLoading , setIsLoading] = useState(false)


      const handleImageChange = (e) => {
        const file = e.target.files[0]
         const storageRef = ref(storage, `Luxgadet/${Date.now()} ${file.name}`)
        const uploadTask = uploadBytesResumable(storageRef, file);
        uploadTask.on('state_changed', 
  
        (snapshot) => {
    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    setUploadProgress(progress)
  }, 
  (error) => {
    // Handle unsuccessful uploads
    toast.error(error.message)
  }, 
  () => {
    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
      setProduct({...product , imageUrl: downloadURL})
      toast.success('image uloaded successfully')

    });
  }
);



      }

      
      const addProduct = (e) => {
        e.preventDefault()
        setIsLoading(true)


        try{ 
          const docRef =  addDoc(collection(db, "products"), {
            name: product.name,
            imageUrl: product.imageUrl,
            category: product.category,
            price:Number(product.price)          ,
            desc: product.desc,
            brand: product.brand,
            color:product.color,
            sizes: product.sizes,
            createdAt: Timestamp.now().toDate()
    
          });
          setIsLoading(false)
          setUploadProgress(0)
          setProduct({...intialState})

          toast.success('product uploaded successfully')
          navigate('/admin/all-products')
          

        }catch(error) {
          setIsLoading(false)

          toast.error(error.message)
        }
      }


      // eedit product 
      const editProduct = (e) => {
        e.preventDefault()
        setIsLoading(true)
        if(product.imageUrl !== productEdit.imageUrl) {
          const storageRef = ref(storage, productEdit.imageUrl);
           deleteObject(storageRef)

        }

        try{
           setDoc(doc(db, "products", id), {
            name: product.name,
            imageUrl: product.imageUrl,
            category: product.category,
            price:Number(product.price)           ,
            desc: product.desc,
            brand: product.brand,
            color:product.color,
            sizes: product.sizes,
            createdAt: productEdit.createdAt,
            editedAt: Timestamp.now().toDate()

          });

          setIsLoading(false)
          toast.success('product edited successfully ')
          navigate('/admin/all-products')

        }catch(error) {
          setIsLoading(false)
          toast.error(error.message)
        }
      }
      

      const handleInputChange = (e) => {
        const {name, value} = e.target
        setProduct({...product , [name]: value})

      }

      const handleSizeChange = (e) => {
        const { value, checked } = e.target;
        const updatedSizes = [...product.sizes];
    
        if (checked) {
          // Add the size to the array if checked
          updatedSizes.push(value);
        } else {
          // Remove the size from the array if unchecked
          const index = updatedSizes.indexOf(value);
          if (index !== -1) {
            updatedSizes.splice(index, 1);
          }
        }
    
        setProduct({ ...product, sizes: updatedSizes });
      };
    
    


      

    return (  

        <>
        {isLoading && <Loader/>}
          <div className={styles['form-container']}>
  <div className={styles['form-wrapper']}>
  {/* detectForm(id, addProduct , editProduct) */}
  <form onSubmit=  {detectForm(id, addProduct , editProduct)}
>
    <div className={styles['form-control']}>
      <h2>{detectForm(id, ' Add New Product', 'Edit new product' )}</h2>
      <label> Product Name</label>
      <input type='text' name="name" value={product.name}  onChange={(e) => handleInputChange(e)}  required />


      </div>
      <div className={styles.group}>
  <label> Product Image</label>

  {uploadProgress === 0 ? null : (

  <div className={styles.progress}>
    <div className={styles['progress-bar']}
      style={{width: `${uploadProgress}%`}}
      >
        {uploadProgress < 100 ? 'uploading' `${uploadProgress}` : `upload complete ${uploadProgress}`}
      


        </div>
        

    </div>
    )}


    <input type="file"    name="image" accept="image/*" placeholder="Product Image"  onChange={(e) => handleImageChange(e)}      />
    {product.imageUrl === '' ? null : (
          <input type="text" name="imageUrl" value={product.imageUrl}  disabled />

    )}


  </div>

    <div className={styles['form-control']}>
    
<label> Product price</label>
  <input type="number" name="price" value={product.price} placeholder="Product price"  onChange={(e) => handleInputChange(e)}  />
  </div>

  <div className={styles['form-control']}>
    
    <label> Product color</label>
      <input type="text" name="color" value={product.color} placeholder="Product Color"  onChange={(e) => handleInputChange(e)}  />
      </div>
    
 
   <div className={styles['form-control']}>
  <label> Product category</label>
  <select name="category" value={product.category}  onChange={(e) => handleInputChange(e)}  >
    <option value='' disabled>--Chaange Product Category--</option>
     {categories.map((cat) => {
    return(
        <option key={cat.id} value={cat.name}>
            {cat.name}

        </option>
    )
})}


  </select>




  </div>
  {/* <div className={styles['form-control']}>
  <label>Product Sizes</label>
  {sizes.map((size) => (
    <div key={size.id} className={styles.checkboxContainer}>
      <input
        type="checkbox"
        id={`size-${size.id}`}
        name={`size-${size.id}`}
        value={size.name}
        checked={product.sizes.includes(size.name)}
        onChange={(e) => handleSizeChange(e)}
      />
      <label htmlFor={`size-${size.id}`}>{size.name}</label>
    </div>
  ))}
</div> */}

<div className={styles['form-control']}>
              <label>Product Sizes</label>
              {sizes.map((size) => (
                <div key={size.id} className={styles.checkboxContainer}>
                  <input
                    type="checkbox"
                    id={`size-${size.id}`}
                    name={`size-${size.id}`}
                    value={size.name}
                    checked={product.sizes.includes(size.name)}
                    onChange={(e) => handleSizeChange(e)}
                  />
                  <label htmlFor={`size-${size.id}`}>{size.name}</label>
                </div>
              ))}
            </div>



  <div className={styles['form-control']}>
    
    <label> Product Brand</label>
    <select name="brand" value={product.brand}  onChange={(e) => handleInputChange(e)}  >
    <option value='' disabled>--Product Brand--</option>
     {productBrand.map((brand) => {
    return(
        <option key={brand.id} value={brand.name}>
            {brand.name}

        </option>
    )
})}


  </select>

      </div>
      <div className={styles['form-control']}>
    
<label> Product Description</label>
  <textarea type="text" name="desc" value={product.desc}  onChange={(e) => handleInputChange(e)}  >

  </textarea>
  </div>

  <button   className={styles.btn}>{detectForm(id , 'Save Product' , 'Edit Product')}</button>







      </form>

    
</div>
</div>
        
        </>

        );
}
 
export default AddProduct;



